export const cannotCreateToast = {
  title: 'この追跡ツールを作成する権限がありません',
  title_auto:
    '追跡ツールを作成する権限がありません。編集権限を有効にするにはストアマネージャーに連絡してください。',
};
